import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {SubmissionError} from 'redux-form'
import {push as pushState} from 'react-router-redux'
import {
  fetchUser,
  signupUser,
  loginUser,
  logoutUser
} from 'redux/modules/currentUser/actions'
import Link from 'components/Link'
import SignUpForm from './SignUpForm'
import omit from 'lodash/omit'
import logos from './images/logos.png'

class SignUp extends React.Component {
  static propTypes = {
    fetchUser: PropTypes.func,
    pushState: PropTypes.func,
    userId: PropTypes.string,
    merchantId: PropTypes.string,
    userWithMerchant: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
    location: PropTypes.object,
    redirectUrl: PropTypes.string,
    logoutUser: PropTypes.func
  }

  componentDidMount() {
    const {fetchUser, isAuthenticated, userId} = this.props

    if (isAuthenticated && !userId) fetchUser()
  }

  componentWillReceiveProps(nextProps) {
    const {userWithMerchant, userId, redirectUrl, pushState} = nextProps

    if (!userId) return false

    if (userWithMerchant && !redirectUrl) {
      pushState('/')
    }
  }

  render() {
    const {location, logoutUser} = this.props
    const query = location.query || {}
    const initialValues = {
      name: [query.firstName, query.lastName].filter(Boolean).join(' '),
      email: query.email
    }

    return (
      <div className='auth-view_content'>
        <div className='auth-view_panel'>
          <div className='auth-view_panel_body'>
            <SignUpForm initialValues={initialValues} onSubmit={this.onSubmit} />
            <p className='auth-view_panel_text is-signup'>
              Already have an account?{' '}
              <Link className='auth-view_panel_text_link' to='/login' onClick={() => {
                logoutUser()
                  .success(() => pushState('/login'))
                  .fail(() => pushState('/login'))
              }}>
                Login
              </Link>
            </p>
          </div>
        </div>
        <div className='auth-view_add'>
          <h3>With Data-Driven you’ll be able to:</h3>
          <ul>
            <li>Discover which channels are over/undervalued</li>
            <li>Learn which channels provide the best ROI</li>
            <li>Understand every customer journey</li>
            <li>Know your exact CAC</li>
          </ul>
          <h3>We’ve worked with great companies</h3>
          <img src={logos} width={460} height={130} />
        </div>
      </div>
    )
  }

  onSubmit = (creds, dispatch) => new Promise((resolve, reject) => {
    const {pushState, merchantId, location} = this.props
    const query = location.query || {}
    const plan = query.plan
    const {email, password} = creds
    dispatch(signupUser(omit(creds, ['terms'])))
      .success(() => (
        dispatch(loginUser({email, password}))
          .success(() => {
            if (merchantId) {
              pushState('/')
            } else {
              const target = plan ? {pathname: '/wizard', search: `?plan=${plan}`} : '/wizard'
              pushState(target)
            }
          })
      ))
      .fail(error => {
        reject(new SubmissionError({_error: error}))
      })
  })
}

const mapStateToProps = state => {
  const {userId, isAuthenticated, merchantId, redirectUrl} = state.currentUser

  return {
    userId,
    isAuthenticated,
    redirectUrl,
    userWithMerchant: isAuthenticated && !!merchantId
  }
}

const mapDispatchToProps = {
  pushState,
  fetchUser,
  logoutUser
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp)



// WEBPACK FOOTER //
// ./client/views/AuthView/SignUp.js